/**
 * Meta Description Analyzer
 * Evaluates the meta description for SEO best practices.
 */

export const analyzeMeta = (data) => {
  const { metaDescription = "" } = data;
  let score = 0;
  let maxScore = 10;
  const results = [];

  if (!metaDescription) {
    return {
      score: 0,
      maxScore,
      results: [{ status: "error", text: "Meta description is missing." }]
    };
  }

  // 1. Meta Description Length (140-160 characters is optimal)
  const len = metaDescription.length;
  if (len >= 140 && len <= 160) {
    score += 10;
    results.push({ status: "success", text: `Meta description length is perfect (${len} characters).` });
  } else if (len < 120) {
    score += 3;
    results.push({ status: "warning", text: `Meta description is too short (${len} chars). Aim for 140-160 characters.` });
  } else if (len >= 120 && len < 140) {
    score += 7;
    results.push({ status: "warning", text: `Meta description is okay (${len} chars), but could be slightly longer.` });
  } else if (len > 160) {
    score += 5;
    results.push({ status: "error", text: `Meta description is too long (${len} chars) and may be truncated.` });
  }

  // Simple duplicate phrase detection (e.g., repeating the same 3-4 words)
  const words = metaDescription.toLowerCase().split(/\s+/);
  if (words.length > 5) {
    let hasDuplicatePhrase = false;
    for (let i = 0; i < words.length - 2; i++) {
      const phrase = `${words[i]} ${words[i+1]} ${words[i+2]}`;
      const restOfString = words.slice(i+3).join(" ");
      if (restOfString.includes(phrase)) {
        hasDuplicatePhrase = true;
        break;
      }
    }
    if (hasDuplicatePhrase) {
      score = Math.max(0, score - 2);
      results.push({ status: "warning", text: "Avoid repeating the same phrases in the meta description." });
    }
  }

  return { score, maxScore, results };
};
